import { render, staticRenderFns } from "./ServersView.vue?vue&type=template&id=5f1f47de&scoped=true"
import script from "./ServersView.vue?vue&type=script&lang=js"
export * from "./ServersView.vue?vue&type=script&lang=js"
import style0 from "./ServersView.vue?vue&type=style&index=0&id=5f1f47de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1f47de",
  null
  
)

export default component.exports